<style type="text/css">
    .small_avatar {
        width: 25px;
        height: 25px;
        border-radius: 25px;
        cursor: pointer;
    }

</style>
<template>
    <v-btn icon class="mx-0">
        <v-icon :class="size" v-if="error" color="primary">account_circle</v-icon>
        <img v-else :src="getAttach()" :class="size" @click="clickAvatar" @error="onLoadImageErr"
             @load="onLoadSuccess"/>
    </v-btn>
</template>

<script>
    export default {
        name: 'i-avatar',
        components: {},
        inheritAttrs: false,
        props: {
            userId: {
                type: String | Number,
                default: () => {
                    return 0;
                }
            },
            size:{
                type: String,
                default: () => {
                    return "small_avatar";
                }

            }
        },
        watch: {
            userId: function (data) {
                this.error = false;
                this.getAttach();
            },
            error: function (data) {
                this.getAttach();
            }
        },

        mounted() {
            //console.log(this.errorMessages);
        },

        created() {
            //console.log("come to create avatar");
        },

        computed: {},

        data: () => {
            return {
                error: false,
            }
        },
        methods: {
            getAttach: function () {
                return process.env.VUE_APP_API_URL + "/download/avatar/" + this.userId;
            },

            clickAvatar: function () {
                this.$emit("click", this.userId);
            },

            onLoadSuccess: function () {
                console.log("success");
                this.error = false;
            },

            onLoadImageErr: function () {
                console.log("load image error");
                console.log(this.userId);
                this.error = true;
            }
        }

    }
</script>
